import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Alert, rem } from '@mantine/core';

interface FeatureUnavailableBannerProps {
    message: string;
}

export const FeatureUnavailableBanner = ({ message }: FeatureUnavailableBannerProps) => (
    <Alert
        color="yellow"
        variant="light"
        icon={<ExclamationTriangleIcon style={{ width: rem(20) }} />}
        mb="md"
    >
        {message}
    </Alert>
);
